import { CONFIRM_ACTION_REQUESTED, PROCEED_ACTION, CANCEL_ACTION } from './actionTypes';

export function confirmActionRequested(actionFunc = () => {}, actionFuncArgs = [], onCancel=()=>{}, onCancelArgs=[], content = null) {
  return {
    type: CONFIRM_ACTION_REQUESTED,
    payload: {
      actionFunc,
      actionFuncArgs,
      onCancel,
      onCancelArgs,
      content
    },
  };
}

export function proceedAction() {
  return {
    type: PROCEED_ACTION,
  };
}

export function cancelAction() {
  return {
    type: CANCEL_ACTION,
  };
}



// WEBPACK FOOTER //
// ./src/services/confirmAction/action.js